import { Component, Input } from "@angular/core";

@Component({
    selector: "m-icon-svg",
    template: `
        <div class="m-icon-svg-container" [class]="styleClass">
            <ng-container *ngIf="iconName; else urlIcon">
                <div class="mi-svg" [class]="iconName"></div>
            </ng-container>

            <ng-template #urlIcon>
                <ng-container *ngIf="iconUrl">
                    <img class="mi-svg" [src]="iconUrl" />
                </ng-container>
            </ng-template>
        </div>
    `
})
export class IconSvgComponent {
    @Input() iconName: string;
    @Input() iconUrl: string;
    @Input() styleClass: string;
}
